
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fourth-litter",
      function () {
        return require("private-next-pages/fourth-litter/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fourth-litter"])
      });
    }
  